import fetchApi from './FetchApi.script';
import apiConfig from './config.json';

export const getGenderOptions = async () => {
  const response = await fetchApi(`/lookups/gender`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': apiConfig.api_key
    },
  });
  return response.json();
}
